import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { AuthParticlesCanvas } from './components/AuthParticlesCanvas'
import '../../../_metronic/assets/sass/anime-auth.scss'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='anime-auth-page-wrapper'>
      {/* ── Background Cyber Grid & Matrix ── */}
      <div className='anime-cyber-grid' />

      {/* ── Animated Telecom Pulse Rings ── */}
      <div className='anime-telecom-pulse-ring pulse-ring-1' />
      <div className='anime-telecom-pulse-ring pulse-ring-2' />
      <div className='anime-telecom-pulse-ring pulse-ring-3' />

      {/* ── Ambient Glowing Aurora Blobs (Navy & Warm Cream) ── */}
      <div className='anime-bg-glow anime-glow-1' />
      <div className='anime-bg-glow anime-glow-2' />
      <div className='anime-bg-glow anime-glow-3' />
      <div className='anime-bg-glow anime-glow-4' />

      {/* ── Interactive Particle System Canvas ── */}
      <AuthParticlesCanvas />

      {/* ── Floating Geometric Corner Accents ── */}
      <div className='anime-geo-shape geo-shape-tl' />
      <div className='anime-geo-shape geo-shape-br' />

      {/* ── Main Form Outlet ── */}
      <Outlet />
    </div>
  )
}

export { AuthLayout }
